import { BaseService, Service } from "/@/cool";
@Service("calcFee")
class CalcFee extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["page"] = prefix + "page";
		this.permission["exportExcel"] = prefix + "exportExcel";
		this.permission["settledFeePage"] = prefix + "settledFeePage";
		this.permission["pendingFeePage"] = prefix + "pendingFeePage";
	}
    settledFeePage(params: any) {
        return this.request({
            url: "/settledFeePage",
            method: "get",
            params
        });
    }
    pendingFeePage(params: any) {
        return this.request({
            url: "/pendingFeePage",
            method: "get",
            params
        });
    }
}
export default CalcFee;
